import { createSvgIcon } from '@mui/material'
import React from 'react'

export const IconInfor = createSvgIcon(
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		width="295px"
		height="296px"
		version="1.0"
		shape-rendering="geometricPrecision"
		text-rendering="geometricPrecision"
		image-rendering="optimizeQuality"
		fill-rule="evenodd" c
		lip-rule="evenodd"
		viewBox="0 0 2950.01 2959.75"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		fill="currentColor"
	>
		<g id="Camada_x0020_1">
			<metadata id="CorelCorpID_0Corel-Layer" />
			<path id="Caminho_3685" d="M2950.01 2950.02l0 -1475.01c0,-814.48 -660.53,-1475.01 -1475.01,-1475.01 -814.47,0 -1474.99,660.53 -1474.99,1475.01 -0.02,1690.31 1772.42,1477.21 2950,1475.01zm-1646.3 -1558.79c-58.34,-0.02 -105.65,-47.33 -105.65,-105.69 0,-58.35 47.31,-105.67 105.67,-105.67l310.39 0c58.35,0 105.67,47.32 105.67,105.67l0.01 1004.35c-0.01,58.32 -47.33,105.64 -105.68,105.64 -58.35,0 -105.67,-47.32 -105.67,-105.67l0 -898.63 -204.74 0zm1433.42 83.78l0 1262.15 -17.99 0c-290.49,0 -579.96,13.84 -870.73,5.9 -417.9,-11.43 -926.79,-64.67 -1260.91,-341.26 -282.57,-233.87 -374.63,-571.46 -374.63,-926.79 0,-696.96 565.2,-1262.16 1262.15,-1262.16 696.96,0 1262.16,565.2 1262.16,1262.16l-0.05 0zm-1093.5 -684.26c0,-93.12 -75.51,-168.63 -168.63,-168.63 -93.1,0 -168.61,75.51 -168.61,168.63 0,93.11 75.51,168.63 168.61,168.63 93.08,-0.02 168.59,-75.54 168.61,-168.63l0.02 0z" data-name="Caminho 3685" />
		</g>
	</svg>,
	'IconInfor',
)
